var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageIcon = function SvgMessageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101.133,
    height: 128.899,
    viewBox: "0 0 101.133 128.899",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    transform: "translate(-527 -1638.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(119.835 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(407.165 1639.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4081",
    "data-name": "Path 4081",
    d: "M1929.822-538.258a13.049,13.049,0,0,1-13.05,13.049h-75.033a13.05,13.05,0,0,1-13.049-13.049v-75.033a13.05,13.05,0,0,1,13.049-13.049h75.033a13.05,13.05,0,0,1,13.05,13.049Z",
    transform: "translate(-1828.69 626.34)",
    fill: "#0a7da7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4085",
    "data-name": "Path 4085",
    d: "M1964.631-233.988l15.577,27.914,15.578-27.914Z",
    transform: "translate(-1929.641 334.974)",
    fill: "#0a7da7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M1089.652,534.457c-6.139,5.82-19.934,18.907-21.959,20.932-.041.052-.084.1-.127.15a3.592,3.592,0,0,1-5.077.243h0c-1.157-.966-12.219-11.606-22.274-21.325ZM1038,536.618c4.1,3.969,11.449,11.062,16.613,15.994L1038,568.617Zm2.025,34.331,16.813-16.2c2,1.906,3.208,3.023,3.573,3.329a7.032,7.032,0,0,0,4.475,1.666,7.108,7.108,0,0,0,5.045-2.242h0c.4-.4,1.33-1.3,2.826-2.728l16.8,16.173Zm51.812-2.1L1075,552.632h0c5.1-4.871,12.618-12.011,16.833-16.008Z",
    transform: "translate(-487.615 1137.604)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-icon.8f698f08.svg";
export { ForwardRef as ReactComponent };